import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as catalogActions from '../../actions/catalogActions';
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from '../../actions/common/modalActions';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import CatalogList from './CatalogList';
import CatalogListDivs from './CatalogListDivs';
import MediaQuery from 'react-responsive';
import CustomModal from '../../components/CustomModal';
import CustomPagination from '../../components/common/CustomPagination';
import {toastr} from 'react-redux-toastr';
import { FormattedMessage } from 'react-intl';
import BaseList from '../../components/common/list/BaseList.jsx';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderTable from "../common/PlaceholderTable";
import PlaceholderError from "../common/PlaceholderError";

class CatalogsPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'catalogs';
        this.idToDelete = null;

        this.state = {
            page: 1,
            showDeleteModal: false,
            actions: this.getRequiredActions()
        };

        if (props.match.params.page) {
            this.state.page = props.match.params.page;
        }

        this.onDelete = this.onDelete.bind(this);
        this.onClone = this.onClone.bind(this);
    }

    getRequiredActions()  {
        return [
            this.props.actions.fetchCatalogs(1)
        ];
    }

    onDelete(id) {
        this.idToDelete = id;
        this.props.actions.showModal();
    }

    confirmDelete() {
        if (this.idToDelete !== null) {
            this.props.actions.deleteCatalog(this.idToDelete).then(() => {
                this.idToDelete = null;
                this.props.actions.fetchCatalogs(this.state.page, this.getSortParams(this.props));
                this.props.actions.hideModal();
                toastr.success(this.props.intl.formatMessage(messages.catalogListCatalogDeleted));
            });
        } else {
            toastr.error(this.props.intl.formatMessage(messages.catalogListErrorDelete));
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.props.actions.hideModal();
    }

    onPageNumberChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.fetchCatalogs(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page: pageNum.selected + 1});
    }

    onClone(catalog) {
        this.props.actions.showSpinner();
        this.props.actions.cloneCatalog(catalog)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.catalogListCatalogCloned));
            })
            .catch(err => {
                this.props.actions.hideSpinner();
                toastr.error(`${this.props.intl.formatMessage(messages.catalogListErrorClone)} #${catalog.id}`);
                throw err;
            })
    }

    render() {
        const { catalogs } = this.props;
        const { data, total } = catalogs;

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable}  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return(
                            <div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.catalogListDeleteModalTitle)}
                                    modalContent={
                                        <p>
                                            {this.props.intl.formatMessage(messages.catalogDeleteModalQuestion)}
                                        </p>
                                    }
                                    confirmText="Slet"
                                    closeText="Annullér"
                                    handleConfirm={() => {this.confirmDelete()}}
                                />
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card m-b-20">
                                            <div className="card-block">
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">{this.props.intl.formatMessage(messages.catalogListTitle)}</h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link
                                                            to="/kataloger/skab"
                                                            className="btn btn-primary waves-effect pull-right"
                                                        >
                                                            {this.props.intl.formatMessage(messages.catalogListCreateCatalog)}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <CatalogListDivs
                                                        catalogs={data}
                                                        onDelete={this.onDelete}
                                                        onClone={this.onClone}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <CatalogList
                                                        catalogs={data}
                                                        onDelete={this.onDelete}
                                                        onClone={this.onClone}
                                                        listId={this.listId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={total}
                                        page={this.state.page}
                                        onPageChange={this.onPageNumberChange.bind(this, addActions)}
                                    />
                                </div>
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state) {
    return {
        catalogs: state.catalogs,
        showDeleteModal: state.showModal,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...catalogActions,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CatalogsPage));


// WEBPACK FOOTER //
// ./web/src/components/catalog/CatalogsPage.jsx